export const ROOM_CONFIG = [
  {
    type: '房间',
    key: 'default',
    data: [
      {
        title: '基础设置',
        key: 'room-base',
        componentName: 'room-base',
      },
      {
        title: '成员权限',
        key: 'role-manage',
        componentName: 'role-manage',
        requirePermissions: ['ManageRoles']
      },
      {
        title: '频道管理',
        key: 'channel-manage',
        componentName: 'channel-manage',
        requirePermissions: ['EditChannel'],
      },
      {
        title: '小表情和大表情',
        key: 'emoji-paster-manage',
        componentName: 'emoji-paster-manage',
        requirePermissions: ['ManageMeme']
      },
      {
        title: '语音包',
        key: 'room-laughter-track-manage',
        componentName: 'room-laughter-track-manage',
        requirePermissions: ['ManageSoundboard'],
      },
      {
        title: '机器人管理',
        key: 'room-bot-manage',
        componentName: 'room-bot-manage',
      },
    ]
  },
  {
    type: '房间新人',
    key: 'new-member',
    data: [
      {
        title:'新手教程',
        key: 'new-member-guide',
        componentName: 'new-member-guide',
        requirePermissions: ['RoomManager'],
        isNew: true,
      },
      {
        title:'房间数据',
        key: 'room-data',
        componentName: 'room-data',
        requirePermissions: [],
      }
    ]
  },
  {
    type: '管理',
    key: 'manage',
    data: [
      {
        title: '安全管理',
        key: 'safety-manage',
        componentName: 'safty-manage',
        requirePermissions: ['RoomManager', 'ViewAuditLog', 'CheckInRoomBlackList'],
      },
      {
        title: '成员管理',
        key: 'member-manage',
        componentName: 'member-manage'
      },
    ]
  },
];

export const HEYGIRL_ADD_COMMUNITY = 'https://static.max-c.com/static/heybox-chat/img/heygirl/heygirl.png';